import { createAsyncThunk } from '@reduxjs/toolkit';
import { RegionalAdministrationsApi } from '../http';
import { IRegionalAdministrations } from '../models';

const regionalAdministrationsApi = new RegionalAdministrationsApi();

export const fetchRegionalAdministrationsRecord = createAsyncThunk(
  'regionalAdministrations/record',
  async (body: { id: IRegionalAdministrations['id'] }, { rejectWithValue }) => {
    try {
      return await regionalAdministrationsApi.findOne(body);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
